import React from "react"
import styled from "styled-components"
import { AppFunctionComponent } from "../../../../types"
import { Overlay, Box, Content } from "../modal.styled"
import { ModalProps } from "../modal.interface"
import CloseButton from "../../close-button/close-button.component"

const Close = styled(CloseButton)`
  position: absolute;
  top: calc(-0.5 * var(--circle-size));
  right: calc(-0.5 * var(--circle-size));
  z-index: 100;
`

export const RawModal: AppFunctionComponent<ModalProps> = ({
  onClose,
  children,
}) => {
  return (
    <>
      <Overlay onClick={onClose} data-testid="modal-overlay" />
      <Box>
        <Content data-testid="modal-content-wrapper">
          <Close onClick={onClose} />
          {children}
        </Content>
      </Box>
    </>
  )
}

export default RawModal
